/* eslint-disable class-methods-use-this */
import qs from 'qs';
import UBT from '@/utils/tianqi';
import { loadHbridge } from '@/utils/globalLoader';
import { getUBTCache, setUBTCache } from './cache';
import { isPowerH5Url } from '../h5Routes';

const getKey = async () => {
  const { env } = await loadHbridge();
  let key;
  if (env.isEasyBikeApp) {
    if (env.isAndroid) {
      key = 'android';
    } else {
      key = 'ios';
    }
  } else {
    key = 'alipay';
  }
  return key;
};

const getKeyTask = getKey();

function getUrl(url) {
  // 历史路由枚举
  let temp = url;
  if (isPowerH5Url(url, (h5Path) => {
    temp = h5Path;
  })) {
    // do nothing
  }
  return temp;
}


function getUBTCacheData(hash = window.location.hash) {
  try {
    // 开仓页，一堆参数（包含source），不做公共埋点
    if (hash.indexOf('#/unlock') === 0) return {};
    // 无参数
    if (hash.indexOf('?') === -1) return {};
    const cache = {};
    const paramsStr = hash.split('?').pop();
    const params = qs.parse(paramsStr);
    if (hash.indexOf('landing-page') > -1) {
      const { url, navigate } = params;
      if (url && url.indexOf('alipays://platformapi/startapp?appId=2018091261337379') === 0) {
        const q = qs.parse(url.split('?').pop());
        if (q && q.query) {
          const query = qs.parse(q.query.split('?').pop());
          if (query.qrCode) {
            const { navigate: _n } = qs.parse(query.qrCode.split('?').pop());

            if (_n) {
              const _url = getUrl(_n);
              return getUBTCacheData(`#/${_url}`);
            }
          }
        }
      } else if (navigate) {
        const _url = getUrl(navigate);
        return getUBTCacheData(`#/${_url}`);
      }
    }
    [
      'cabinetId',
      'merchant',
      'source',
      'activityCode',
      'thirduid',
    ].forEach((key) => {
      if (params[key]) {
        cache[key] = params[key];
      }
    });
    return cache;
  } catch (e) {
    return {};
  }
}

// h5打开时，设置缓存
const setUBTCacheInitTask = setUBTCache(getUBTCacheData());
export default class IBase {
  async pv(pageIds, businessInfo = {}) {
    await setUBTCacheInitTask;
    const cache = await getUBTCache();
    const key = await getKeyTask;
    const pageId = typeof pageIds === 'string' ? pageIds : pageIds[key];
    UBT.pageView({
      pageId,
      businessInfo: {
        ...cache,
        ...businessInfo,
      },
    });
  }

  async pvo(pageId, businessInfo = {}) {
    await setUBTCacheInitTask;
    const cache = await getUBTCache();
    UBT.pageViewOut({
      pageId,
      businessInfo: {
        ...cache,
        ...businessInfo,
      },
    });
  }

  async ck(e, businessInfo = {}) {
    await setUBTCacheInitTask;
    const cache = await getUBTCache();
    const key = await getKeyTask;
    const obj = e.alipay || e.android || e.ios ? e[key] : e;
    UBT.clickButton({
      ...obj,
      businessInfo: {
        ...cache,
        ...businessInfo,
      },
    });
  }

  async opt(pointId, businessInfo) {
    await setUBTCacheInitTask;
    const cache = await getUBTCache();
    UBT.customEventWithPointId({
      pointId, // 必填，事件ID
      businessInfo: {
        ...cache,
        ...businessInfo,
      },
    });
  }

  async me(pageId, moduleId, contentId, exposureTimes, businessInfo = {}) {
    await setUBTCacheInitTask;
    const cache = await getUBTCache();
    UBT.moduleExpose({
      pageId, // 必填，事件ID
      moduleId,
      contentId,
      exposureTimes,
      businessInfo: {
        ...cache,
        ...businessInfo,
      },
    });
  }
}
